import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure, useToast } from '@chakra-ui/react';

import { createInventoryCount } from 'api/inventory';
import { toApiPayloadDateFormat } from 'utils/dateUtils';

import { useMutation, useQueryClient } from 'react-query';

import {
  RefType,
  AddInventoryCountModalProps,
} from './AddInventoryCountModal.props';

import AddInventoryCountModalView from './AddInventoryCountModal.view';

const AddInventoryCountModalContainer = forwardRef<
  RefType,
  AddInventoryCountModalProps
>((props, ref) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate, isLoading } = useMutation(createInventoryCount, {
    onSuccess: () => {
      toast({
        status: 'success',
        isClosable: true,
        description: 'Inventory count created',
      });

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('fetch-inventory-counts'), //This will invalidate all queries that have 'fetch-inventory-counts' anywhere in their query key
      });

      onClose();
    },
  });

  useImperativeHandle(ref, () => ({ onOpen }), []);

  const onSubmit = (payload: any) => {
    if (payload.countDate) {
      payload.countDate = toApiPayloadDateFormat(payload?.countDate);
    }

    mutate(payload);
  };

  return (
    <AddInventoryCountModalView
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
      showTick={false}
    />
  );
});

const AddInventoryCountModal = memo(AddInventoryCountModalContainer);

export default AddInventoryCountModal;
